import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=6bf401ac&scoped=true&"
import script from "./camera.vue?vue&type=script&lang=js&"
export * from "./camera.vue?vue&type=script&lang=js&"
import style0 from "./camera.vue?vue&type=style&index=0&id=6bf401ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf401ac",
  null
  
)

export default component.exports